import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import throttle from 'lodash/throttle';
import styled from 'styled-components';

// Styled Components
import { SmartContainer, Stack, HorizontalStack } from '../../styles/Containers';
import { StyledChip } from '../../styles/matieralui/Chip';
import { splitAndTrim } from '../../services/Utils';

// Components
import { Autocomplete } from '../Forms/Autocomplete';
import { StyledB, StyledP } from '../../styles/StyledHTML';

const StyledChipInline = styled(StyledChip)`
    margin-bottom: 1em !important;
`




export const TagSelectorWithAutoComplete = ({ helperText = null, noLabels = false, inputLabel = "search", label, helper = null, existingOptions, selector, action, onChange, limit = null, renderOption, staticOptions = null }) => {

    // ------------------------------
    // State
    // ------------------------------

    const dispatch = useDispatch();
    const [value, setValue] = useState(null);
    const [options, setOptions] = useState([])


    const data = selector();
    const [activeTags, setActiveTags] = useState([])
    const [tagsLoaded, setTagsLoaded] = useState(false);

    // ------------------------------
    // State
    // ------------------------------

    const newTag = ''
    const [loaded, setLoaded] = useState(false);


    // ------------------------------
    // Effects
    // ------------------------------

    useEffect(() => {
        if (existingOptions && loaded !== true && options) {
            setLoaded(true);
            const active = tagDifferenceById(existingOptions);
            setActiveTags(active);

        } else if (existingOptions && loaded !== true) {
            setLoaded(true);
            const active = tagDifferenceById(existingOptions);
            setActiveTags(active);


        }

    }, [existingOptions, options])

    // Save Tags
    useEffect(() => {


        // Save Tag Changes
        if (onChange) {
            if (loaded) {
                onChange(activeTags)
            }
        }

    }, [activeTags])

    useEffect(() => {

        if (data?.tageditor?.rows) {

            const formatted = data?.tageditor?.rows.map(u => {
                const f = { ...u };
                return f;
            })
            setOptions(formatted)
        }
        else if (data?.tageditor?.rows?.length <= 0) {
            setOptions(null)
        }
    }, [data?.tageditor?.rows])

    // ------------------------------
    // Methods
    // ------------------------------

    const handleRemoveTag = (tag) => {
        if (!tag) return;
        const tags = activeTags.filter(theTag => tag.name !== theTag.name);
        setActiveTags([...tags])
    }

    const handleAddTag = (tag) => {

        if (!tag) {
            return;
        }
        if (!loaded) {
            setLoaded(true); // Just added for onboarding. Remove if causing problems.
        }
        const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
        if (!exists) setActiveTagsFormat([...activeTags, tag])
    }
    const setActiveTagsFormat = (arr) => {

        // Make Sure There Are No Duplicates
        const storage = []
        const filtered = arr.filter(item => {
            if (!storage.includes(String(item.name).toLowerCase())) {
                storage.push(String(item.name).toLowerCase())
                return item;
            }
            return false;

        })
        setActiveTags(filtered)
    }



    const tagDifferenceById = (arr) => {
        if (!arr) return [];

        const tags = arr.filter(tag => {
            const optExist = options.filter(theTag => tag.id === theTag.id).length;
            const staticExist = staticOptions.filter(theTag => tag.id === theTag.id).length;

            if (optExist) return optExist;
            if (staticExist) return staticExist;
            return tag;

        })

        return tags;
    }


    const tagDifference = () => {

        // Works for Polling server
        // if (!options) return [];
        // const tags = options.filter(tag => {
        //     const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
        //     return !exists;
        // })
        // return tags;
        if (!options && !staticOptions) return [];

        // Check Static First
        if (staticOptions) {

            const tags = staticOptions?.filter(tag => {
                const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
                return !exists;
            })

            const stags = options?.filter(tag => {
                const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
                return !exists;
            })
            return [...tags, ...stags]
        }

        // Check Options from Server 2nd
        const tags = options.filter(tag => {
            const exists = activeTags.filter(theTag => tag.name === theTag.name).length;
            return !exists;
        })
        return tags;
    }

    const isNewTag = (val) => {
        const found = tagDifference();
        const name = (val?.id) ? val.name : val;

        const x = found?.filter(i => {
            const lower = i?.name.toLowerCase();
            if (lower === name.toLowerCase()) return true;
            return false;
        })

        return (x?.length <= 0) ? true : false;

    }


    const handleNewTag = (name) => {

        // Guard: Empty Album Name
        if (name?.length <= 0) return;
        // Object FOund
        if (name?.id) {
            handleAddTag(name);
        } else if (name.indexOf(',') > -1) {
            let formatted = splitAndTrim(name, ',').map(item => {
                const isItNew = isNewTag(item);
                if (!isItNew) return false;
                return { name: item };
            })

            formatted = formatted.filter(i => i !== false);

            setActiveTagsFormat([...activeTags, ...formatted]);
        } else {
            // Ensure that the Name doesn't already exist.
            const isItNew = isNewTag(name);
            if (!isItNew) return;
            handleAddTag({ name }) // Single Value
            // Clear value
            setValue('')

        }

    }

    const onEnter = (v) => {

        handleNewTag(v);
    }

    // const onSearch = (searchString) => {
    //     const args = {}
    //     args['prefix'] = 'tageditor';

    //     if (!searchString) return;
    //     dispatch(action(0, 5, searchString, 'all', args))

    // }

    const onSearch = (searchString) => {
        const args = {}
        args['prefix'] = 'tageditor';

        if (!searchString) return;
        if (!staticOptions) dispatch(action(0, 5, searchString, 'all', args))
        else {
            // Don't poll the server until nothing is found in the static list
            const found = tagDifference();

            const x = found?.filter(i => {
                const name = i?.name.toLowerCase();
                if (name.indexOf(searchString.toLowerCase()) >= 0) return i;
                return false;
            })

            if (x?.length <= 0) {
                dispatch(action(0, 5, searchString, 'all', args))
            }
        }


    }


    // ------------------------------
    // Render
    // ------------------------------

    const renderTags = (tags) => {
        if (!tags) return (<div></div>)
        return tags.map(tag => (
            <StyledChipInline key={tag.id} label={tag.name} clickable onDelete={() => handleRemoveTag(tag)} />
        ))
    }

    const renderAutoComplete = (opts) => {
        // if (!opts) return null;
        if (limit !== null && activeTags?.length >= limit) return null;
        return (
            <Autocomplete
                width="100%"
                label={inputLabel}
                onSearch={onSearch}
                options={tagDifference()}
                optionLabelKey="name"
                onChange={handleAddTag}
                value={value}
                type="text"
                noOptionsTextAction={handleNewTag}
                noOptionsText="Add New"
                onEnter={onEnter}
                helperText={helperText}
                renderOption={renderOption}
                loading={data?.tageditorLoading}
            />
            // <Autocomplete
            //             label={formLabel}
            //             onSearch={onSearch}
            //             options={tagDifference()}
            //             onChange={handleNewTag}
            //             type="text"
            //             value={value}
            //             noOptionsTextAction={handleNewTag}
            //             noOptionsText="Add New"
            //             optionLabelKey="readableString"
            //             loading={data?.tageditorLoading}
            //         />
        )
    }

    return (
        <SmartContainer width="100%">

            <SmartContainer width="100%">
                {!noLabels && (
                    <SmartContainer>
                        <StyledP><StyledB>{label}</StyledB></StyledP>
                        {helper && (<StyledP light>{helper}</StyledP>)}
                    </SmartContainer>
                )}


                <HorizontalStack width="100%">{renderTags(activeTags)}</HorizontalStack>

                {renderAutoComplete(options)}
            </SmartContainer>
        </SmartContainer>
    )
}